<header class="app-header" data-module="govuk-header">
    <div class="govuk-header__container app-header__container app-width-container">
        <div class="govuk-width-container">
            <div class="header-badge">
                <a  (click)="goToWebsite()" class="govuk-header__link govuk-header__link--homepage"></a>
            </div>
        </div>
    </div>
</header>